<template>
  <div class="questionStoreDetail">
    <div class="topBar">
      <div class="searchBox">
        <el-input
          v-model="questionName"
          placeholder="请输入题干名称"
          clearable
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        ></el-input>
        <el-button type="primary" @click="handleSearch">查 找</el-button>
      </div>
      <el-button class="backBtn" @click="handleBack">返 回</el-button>
    </div>
    <div v-loading="loading" class="questionList">
      <div v-for="(item, index) in questionList" :key="item.questionId" class="questionBox">
        <div class="nameType">
          <div class="type">【{{ questionTypeMap[item.questionType] || '未知题型' }}】</div>
          <div class="score">（本题{{ item.score }}分）</div>
          <el-button
            class="delBtn"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(item)"
          ></el-button>
        </div>
        <div class="question">
          <div class="questionIndex">{{ questionIndex(index) }}.</div>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="questionName" v-html="item.questionName"></div>
        </div>
        <div v-if="item.optionList && item.optionList.length && isChoiceType(item)" class="optionList">
          <div v-for="(v, key) in item.optionList" :key="key" class="optionBox">
            <div class="optionTag" :class="{ active: isRightOption(item, v) }">
              {{ v.optionTag }}
            </div>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="optionName" v-html="v.optionName"></div>
          </div>
        </div>
        <div v-else-if="rightAnswerText(item)" class="answerText">
          答案：
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span class="answerValue" v-html="rightAnswerText(item)"></span>
        </div>
      </div>
      <el-empty
        v-if="!loading && !questionList.length"
        :image-size="80"
        description="暂无试题"
      ></el-empty>
    </div>
    <div class="pagerBox">
      <el-pagination
        :current-page="pager.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pager.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pager.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
// 题型编码转换（1-单选 2-多选 3-计算 4-判断 5-填空 6-简答 ...）
const questionTypeMap = {
  1: '单选题',
  2: '多选题',
  3: '计算题',
  4: '判断题',
  5: '填空题',
  6: '简答题',
  7: '论述题',
  8: '案例分析题',
  9: '综合题',
}
import { questionStoreDetailPage, questionStoreDeleteQuestion } from '@/api/exam'
import to from 'await-to'
export default {
  name: 'QuestionStoreDetail',
  data() {
    return {
      questionTypeMap,
      questionStoreId: this.$route.query.id,
      questionName: '',
      loading: false,
      questionList: [],
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
    }
  },
  mounted() {
    this.getDetailPage()
  },
  methods: {
    async getDetailPage() {
      if (!this.questionStoreId) return this.$message.warning('缺少题库id')
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(
        questionStoreDetailPage({
          current,
          size,
          questionStoreId: this.questionStoreId,
          questionName: this.questionName,
        }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.questionList = res.data.list || []
      this.pager.total = res.data.total || 0
    },
    // 题干模糊查询
    handleSearch() {
      this.pager.current = 1
      this.getDetailPage()
    },
    // 返回上一页
    handleBack() {
      this.$router.push('/exam/questionStore')
    },
    // 删除试题
    handleDelete(item) {
      this.$confirm('确定删除该试题吗？', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning',
      }).then(async () => {
        const [, err] = await to(
          questionStoreDeleteQuestion({
            questionId: item.questionId,
            questionStoreId: this.questionStoreId,
          }),
        )
        if (err) return this.$message.warning(err.msg)
        this.$message.success('删除成功')
        // 当前页删空后回退一页
        if (this.questionList.length === 1 && this.pager.current > 1) {
          this.pager.current -= 1
        }
        this.getDetailPage()
      })
    },
    // 选项是否为正确答案
    isRightOption(item, option) {
      if (item.rightOptionList && item.rightOptionList.length) {
        return item.rightOptionList.some(v => v.optionTag === option.optionTag)
      }
      return option.isRightKey === 1
    },
    // 选择题型（1-单选 2-多选 4-判断）按选项展示，其余题型直接显示答案
    isChoiceType(item) {
      return [1, 2, 4].includes(Number(item.questionType))
    },
    // 非选择题答案文本
    rightAnswerText(item) {
      if (item.rightOptionList && item.rightOptionList.length) {
        return item.rightOptionList.map(v => v.optionName).join('；')
      }
      // 填空/简答/论述等主观题的答案可能在 optionList 中（单个 A 选项）
      if (item.optionList && item.optionList.length) {
        return item.optionList.filter(v => v.isRightKey === 1).map(v => v.optionName).join('；')
      }
      return ''
    },
    // 题号跨页连续
    questionIndex(index) {
      return (this.pager.current - 1) * this.pager.size + index + 1
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getDetailPage()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getDetailPage()
    },
  },
}
</script>
<style scoped lang="scss">
.questionStoreDetail {
  height: 100%;
  overflow-y: auto;
  padding: 20px;
  background: #fff;
  box-sizing: border-box;
  .topBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    .searchBox {
      display: flex;
      align-items: center;
      .el-input {
        width: 240px;
        margin-right: 10px;
      }
    }
    .backBtn {
      width: 90px;
    }
  }
  .questionList {
    .questionBox {
      padding: 10px 0 20px;
      & + .questionBox {
        border-top: 1px solid #f0f0f0;
      }
      .nameType {
        display: flex;
        align-items: center;
        .type {
          color: #3671bf;
          font-weight: bold;
          font-size: 14px;
        }
        .score {
          margin-left: 10px;
          color: #999;
          font-size: 14px;
        }
        .delBtn {
          margin-left: auto;
          padding: 5px;
          font-size: 20px;
          color: #3671bf;
        }
      }
      .question {
        display: flex;
        margin: 10px 0;
        font-size: 15px;
        line-height: 24px;
        .questionIndex {
          flex-shrink: 0;
        }
        .questionName {
          word-break: break-all;
        }
      }
      .optionList {
        .optionBox {
          display: flex;
          align-items: center;
          margin: 12px 0;
          .optionTag {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            border: 1px solid #dcdfe6;
            border-radius: 50%;
            font-size: 14px;
            color: #606266;
            background: #f5f7fa;
            &.active {
              border-color: #3671bf;
              background: #3671bf;
              color: #fff;
            }
          }
          .optionName {
            margin-left: 12px;
            font-size: 14px;
            color: #606266;
            word-break: break-all;
          }
        }
      }
      .answerText {
        margin-top: 10px;
        font-size: 14px;
        color: #606266;
        .answerValue {
          word-break: break-all;
        }
      }
    }
  }
  .pagerBox {
    display: flex;
    justify-content: flex-end;
    padding: 20px 0 5px;
  }
}
</style>
